import { DEFAULT_LANGUAGE, DEFAULT_REGION } from "../../utils/locale.utils";
import locales from "../../locales/index";
import * as locale from "../actions/locale.actions";

const INITIAL_STATE = {
  language: DEFAULT_LANGUAGE,
  region: DEFAULT_REGION,
  availableLocales: Object.keys(locales)
};

export function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case locale.SET:
      return {
        ...state,
        language: action.payload.language,
        region: action.payload.region
      };
    default:
      return state;
  }
}

export const getLanguage = state => state.language;
export const getRegion = state => state.region;
export const getAvailableLocales = state => state.availableLocales;
